/**
 * iter179 — ModuleGate: route-level Access + Lock enforcement.
 *
 * Wraps a protected screen and:
 *   • Redirects to `/` when the module's `access === 'disabled'`.
 *   • Shows a "Please upgrade your plan" toast + redirects to `/` when
 *     the module is `locked`. Both are handled at the route boundary so
 *     even a hard refresh / paste-URL flow respects the admin config.
 *
 * Fail-open: while config is loading OR on a network error, the child
 * renders — the App never becomes unusable on a config outage.
 */
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useModuleConfig } from '../context/ModuleConfigContext';

const ModuleGate = ({ module: moduleKey, children }) => {
  const { isVisible, isLocked, loading } = useModuleConfig();

  const hidden = !loading && !isVisible(moduleKey);
  const locked = !loading && isVisible(moduleKey) && isLocked(moduleKey);

  useEffect(() => {
    if (locked) {
      toast.message('Please upgrade your plan', {
        description: 'This module is included in a higher plan.',
      });
    }
  }, [locked]);

  if (hidden || locked) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ModuleGate;
